import React from "react";
import { withTranslation } from "react-i18next";
import Alerts from "../Alerts/Alerts";
import AlertsList from "../AlertsList/AlertsList";
import ShipmentCharts from "../ShipmentCharts/ShipmentCharts";

function TelemetryPanel({
  shipmentCode,
  telemetryInfo,
  alertsListInfo,
  chartsInfo,
  batteryLevels,
  isStandalone,
  variant,
  stepsRef,
}) {
  return (
    <>
      <Alerts
        shipmentCode={shipmentCode}
        telemetryInfo={telemetryInfo}
        hasTelemetry
        batteryLevels={batteryLevels}
        isStandalone={isStandalone}
        variant={variant}
      />

      <AlertsList
        shipmentCode={shipmentCode}
        alertsListInfo={alertsListInfo}
        variant={variant}
      />

      <ShipmentCharts
        shipmentCode={shipmentCode}
        chartsInfo={chartsInfo}
        isStandalone={isStandalone}
        variant={variant}
        alertsListInfo={alertsListInfo}
        stepsRef={stepsRef}
      />
    </>
  );
}

export default withTranslation()(TelemetryPanel);
